import gql from "graphql-tag";
const ADD_MAS_FROM_IMDBID = gql `
  mutation addMASFromImdbId($imdbId: String!) {
    addMASFromImdbId(imdbId: $imdbId) {
      id
    }
  }
`;
export default ADD_MAS_FROM_IMDBID;
